import { useField } from 'formik';
import { ButtonGroup, Form, InputGroup, Col } from 'react-bootstrap';
import starIcon from 'assets/img/star_filled.svg';
import './styles.scss';
import {useWindowSize} from 'hooks';

export default function RankingButton({
  options = [],
  groupClassName = 'my-2',
  onChange,
  label = '',
  variant = 'number',
  ...rest
}) {
  const [field, , helpers] = useField(rest);
  const [,{isMobile}] = useWindowSize()

  const handleClick = (value) => {
    if (onChange) onChange({ target: { value } });

    helpers.setValue(value);
  };

  const RenderLabel = () => {
    if (!label) return null;

    const requiredLabel = label.includes('*');
    const finalLabel = requiredLabel ? label.replace('*', '') : label;

    return (
      <Form.Label column xs={12}>
        {finalLabel} {requiredLabel && <p className="MarkupRequiredField">*</p>}
      </Form.Label>
    );
  };

  return (
    <InputGroup className={`Input ${groupClassName}`}>
      {RenderLabel()}
      <Col xs={12} className="px-0">
        <ButtonGroup className="RankingButton me-2" aria-label="First group">
          {options.map((option, i) => {
            const index = i + 1;
            return (
              <>
                {variant === 'stars' ? (
                  <div
                    className={`RankingButton__Stars RankingButton__Stars--${
                      field.value && Number(field.value) >= index
                        ? 'active'
                        : 'inactive'
                    }`}
                    role="button"
                    tabIndex="0"
                    onClick={() => handleClick(index)}
                    onKeyPress={() => handleClick(index)}
                  >
                    <img src={starIcon} alt={`Estrella ${index}`} 
                      style={{
                        width: isMobile ? '2.5rem' : '3.3rem',
                      }}
                    />
                  </div>
                ) : (
                  <div
                    className={`RankingButton__Button RankingButton__Button--${
                      field.value && Number(field.value) >= index
                        ? 'active'
                        : 'inactive'
                    }`}
                  >
                    <button
                      key={option.value}
                      onClick={() => handleClick(option.value)}
                      onKeyPress={() => handleClick(index)}
                      type="button"
                      style={{
                        fontSize: isMobile ? '12px' : '16px',
                        height: isMobile ? '28px' : '34px',
                        width: isMobile ? '28px' : '34px',
                      }}
                    >
                      {index}
                    </button>
                  </div>
                )}
              </>
            );
          })}
        </ButtonGroup>
      </Col>
    </InputGroup>
  );
}
